import React from "react";
import { GiChatBubble } from "react-icons/gi";

import { useApp } from "../../contexts/AppContext";
import { ReactComponent as ESCLogo } from "../../assets/logo.svg";

function Header({ onOpenChat }: { onOpenChat?: () => void }) {
  const {
    state: {
      event,
      party,
      myPartyUsers,
      selectedPartyId,
      chatUnread,
    },
    setSelectedPartyId,
  } = useApp();

  const canGoBackToParties =
    selectedPartyId !== null && myPartyUsers.length > 0;

  return (
    <header className="sticky z-10 top-0 flex items-center justify-between text-white p-4 bg-gradient-to-b from-black via-black/70 to-black/0 gap-3">
      {!party && (
        <h1 className="flex-1 text-2xl inline-flex font-montserrat font-semibold items-center justify-center">
          Eurovision
          <span className="w-12 h-12 mx-2">
            <ESCLogo />
          </span>
          Party
        </h1>
      )}

      {party && event && (
          <div className="absolute left-12 right-12 top-0 bottom-0 text-center flex items-center justify-center">
            <h1 className="text-lg font-montserrat font-semibold leading-none">
              {party.name}
              {["pre-contest", "score-songs"].includes(event.stage) && (
                <span className="block text-base font-montserrat">
                    <span className="tracking-widest text-esc-pink">
                      {party.shortId}
                    </span>
                </span>
              )}
            </h1>
          </div>
      )}
      {canGoBackToParties && (
        <>
        <button
          type="button"
          onClick={() => setSelectedPartyId(null)}
          aria-label="Show all parties"
          className="flex-none inline-flex items-center gap-1 border border-white/40 px-2 py-1 text-sm font-montserrat bg-white/20 hover:bg-white/40"
        >
          <span aria-hidden="true">←</span>
        </button>
        <div className="flex-1" />
        {/* <p className="text-xl">👤 {partyUsers?.length ?? '?'}</p> */}
        {onOpenChat && (
          <button
            type="button"
            onClick={onOpenChat}
            aria-label="Open party chat"
            className="relative flex-none inline-flex items-center justify-center w-9 h-9 border border-white/40 bg-white/20 hover:bg-white/40 text-white"
          >
            <GiChatBubble size={20} aria-hidden="true" />
            {chatUnread && (
              <span
                aria-label="New messages"
                className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-esc-yellow ring-2 ring-black"
              ></span>
            )}
          </button>
        )}
        </>
      )}
    </header>
  );
}

export default Header;
